import { AgmCoreModule } from '@agm/core';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { CUSTOM_ELEMENTS_SCHEMA, LOCALE_ID, NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { Ng9RutModule } from 'ng9-rut';
// import { HttpModule } from '@angular/http';
import { HttpClientModule } from '@angular/common/http';
import { RouterModule } from '@angular/router';
import { AppComponent } from './app.component';
import { AppRoutes } from './app.routes.service';

import { Apollo, ApolloModule } from 'apollo-angular';
import { HttpLink, HttpLinkModule } from 'apollo-angular-link-http';
import { InMemoryCache } from 'apollo-cache-inmemory';
import { setContext } from 'apollo-link-context';
import { API_URL } from '../environments/environment';

import { registerLocaleData } from '@angular/common';
import { formatoRutDirective } from './shared/directivas/formatoRut.directive';
import { SharedModule } from './shared/shared.module';
import { ErrorModule } from './views/errors/error.module';
import { ViewsModule } from './views/views.module';
import { ModalResultadosConversionComponent } from './shared/components/modal-resultados-conversion/modal-resultados-conversion.component';

import localeCL from '@angular/common/locales/es-CL';

registerLocaleData(localeCL, 'es-CL');


// main layout
import { NavigationModule } from './main-layout/navigation/navigation.module';

import { MDB_DATE_OPTIONS, MDBBootstrapModulesPro, MDBSpinningPreloader, ToastModule } from 'ng-uikit-pro-standard';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { createUploadLink } from 'apollo-upload-client';
import { SignalRMessageService } from './services/SignalRMessage.service';
import { SignalRService } from './services/SignalRNegotiate.service';
import { StorageVariable } from './shared/object/local-storage-variable.enum';


@NgModule({
  declarations: [
    AppComponent,
    formatoRutDirective,
    ModalResultadosConversionComponent
  ],
  imports: [
    BrowserModule,
    ScrollingModule,
    Ng9RutModule,
    BrowserAnimationsModule,
    NavigationModule,
    AppRoutes,
    // HttpModule,
    HttpClientModule,
    ApolloModule,
    HttpLinkModule,
    RouterModule,
    SharedModule,
    ViewsModule,
    ReactiveFormsModule,
    FormsModule,
    ErrorModule,
    ToastModule.forRoot(),
    MDBBootstrapModulesPro.forRoot(),
    AgmCoreModule.forRoot({
      // https://developers.google.com/maps/documentation/javascript/get-api-key?hl=en#key
      // apiKey: 'AIzaSyAYIdI9452IG2Mw2b1uSmi4p39EcPkBtUg',
      apiKey: 'AIzaSyAAtnike-hAZm2LShhn4tUVNu1Nii8hlX8',
      libraries: ['places', 'drawing', 'geometry'],
      language: 'es'
    })
  ],
  providers: [MDBSpinningPreloader, { provide: LOCALE_ID, useValue: 'es-CL' }, {
    provide: MDB_DATE_OPTIONS, useValue: {
      dayLabels: { su: 'Dom', mo: 'Lun', tu: 'Mar', we: 'Mie', th: 'Jue', fr: 'Vie', sa: 'Sab' },
      dayLabelsFull: { su: 'Domingo', mo: 'Lunes', tu: 'Martes', we: 'Miércoles', th: 'Jueves', fr: 'Viernes', sa: 'Sábado' },
      //monthLabels: { 1: 'Ene', 2: 'Feb', 3: 'Mar', 4: 'Abr', 5: 'May', 6: 'Jun', 7: 'Jul', 8: 'Ago', 9: 'Sep', 10: 'Oct', 11: 'Nov', 12: 'Dic' },
      //monthLabelsFull: { 1: 'Enero', 2: 'Febrero', 3: 'Marzo', 4: 'Abril', 5: 'Mayo', 6: 'Junio', 7: 'Julio', 8: 'Agosto', 9: 'Septiembre', 10: 'Octubre', 11: 'Noviembre', 12: 'Diciembre' },
      dateFormat: 'yyyy-mm-dd',
      todayBtnTxt: 'Hoy',
      clearBtnTxt: 'Limpiar',
      closeBtnTxt: 'Cerrar',
      ariaLabelPrevMonth: 'Mes anterior',
      ariaLabelNextMonth: 'Mes siguiente',
      firstDayOfWeek: 'mo',
      sunHighlight: true,
      closeAfterSelect: true,
      alignSelectorRight: true,
      markCurrentDay: true,
      width: '180px',
    }
  }, SignalRMessageService, SignalRService],
  bootstrap: [AppComponent],
  schemas: [NO_ERRORS_SCHEMA, CUSTOM_ELEMENTS_SCHEMA]
})

export class AppModule {

  constructor(apollo: Apollo, httpLink: HttpLink) {
    //const http = httpLink.create({uri: API_URL});


    const http = createUploadLink(
      { uri: API_URL, }
    );

    const auth = setContext((_, { headers }) => {
      const token = sessionStorage.getItem(StorageVariable.ACCESS_TOKEN_KEY);

      if (!token) {
        return {};
      } else {
        return {
          headers: { 'Authorization': token }
        };
      }
    });

    apollo.create({
      link: auth.concat(http),
      cache: new InMemoryCache(),
    });


  }

}
